<template>
  <div>
    <b-card class="mt-4">
      <div>
        <b-overlay rounded="sm">
          <div class="row pb-3">
            <div class="col">
              <h3>Klienci</h3>
            </div>
            <div class="col">
              <button type="button" class="btn btn-primary float-right" @click="OpenNewClientModal">
                <i class="fas fa-plus-circle fa-1x"></i> Dodaj nowego klienta
              </button>
            </div>
          </div>
          <div v-if="clients.length > 0">
            <table class="table table-striped">
              <thead>
              <tr>
                <th>Nazwa</th>
                <th>Nip</th>
                <th>Kraj</th>
                <th>Akcje</th>
              </tr>
              </thead>
              <tbody>
              <tr v-for="item in clients" :key="item.id">
                <td> {{ item.name }}</td>
                <td> {{ item.nip }}</td>
                <td> {{ item.countryName }}</td>
                <td>
                  <div class="row" style="display: flex">
                    <button type="button" class="btn btn-primary btn-sm" @click="OpenEditClientModal(item)">
                      Edytuj
                    </button>
                  </div>
                </td>
              </tr>
              </tbody>
            </table>
          </div>
          <div v-else>
            <h4>Brak klientów</h4>
          </div>
        </b-overlay>
      </div>
      <ManageClient @ClientWasAdded="GetClients()" ref="addClient"/>
    </b-card>
  </div>
</template>

<script>
import toastr from "../../../mixins/toastr";
import ManageClient from "@/components/Administration/Modals/Client/ManageClient.vue";
import ClientMixin from "@/mixins/clientMixin";

export default {
  name: "ProducerAdministration",
  components: {
    ManageClient,
  },
  mixins: [toastr,ClientMixin],
  created() {
    this.getClients()
  },
  data() {
    return {
      selectedClient: undefined,
      items: [],
      isLoaded: false,
    };
  },
  methods: {
    OpenNewClientModal() {
      this.$bvModal.show("AddClient");
    },
    OpenEditClientModal(item) {
      const addClientModalRef = this.$refs.addClient;
      addClientModalRef.nip = item.nip;
      addClientModalRef.userName = item.name;
      addClientModalRef.country = item.countryId;
      addClientModalRef.id = item.id;
      this.$bvModal.show("AddClient");
    },
  },
};
</script>
